import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FilterContentTypes, } from '@as-react/common-types';
import { Stack, TextAlpha } from '@yonderland/andes-react';
import { FILTER_SIZE_SEPARATOR } from '../../../../constants/GeneralConstants';
import { FiltersSizeItem } from './FiltersSizeItem';
export const FiltersSizes = ({ items, type, filter, toggleFilterValue, desktop, search }) => {
    var _a;
    const isSizeCategoryFilter = (_a = items[0]) === null || _a === void 0 ? void 0 : _a.name.includes(FILTER_SIZE_SEPARATOR);
    const isSizeFilterContentType = filter.filterContentType === FilterContentTypes.SIZE;
    if (isSizeFilterContentType && isSizeCategoryFilter) {
        const filterMap = {};
        items.map(filterItem => {
            const filterName = filterItem.name.split(FILTER_SIZE_SEPARATOR)[1];
            if (filterName && filterMap[filterName]) {
                filterMap[filterName].push(filterItem);
            }
            else if (filterName) {
                filterMap[filterName] = [filterItem];
            }
        });
        const filterEntries = Object.entries(filterMap);
        return (_jsx(_Fragment, { children: filterEntries.map(([filterName, filterValues]) => (_jsxs(Stack, { gap: "2", direction: "col", children: [_jsx(TextAlpha, { strong: true, children: filterName }), _jsx(Stack, { gap: "2", direction: "col", children: filterValues.map((item) => (_jsx(FiltersSizeItem, { item: item, toggleFilterValue: toggleFilterValue, desktop: desktop, filter: filter, type: type, search: search }, item.filterKey))) })] }, filterName))) }));
    }
    return (_jsx(Stack, { gap: "2", direction: "col", children: items.map((item) => (_jsx(FiltersSizeItem, { item: item, toggleFilterValue: toggleFilterValue, desktop: desktop, filter: filter, type: type, search: search }, item.filterKey))) }));
};
